import { render, staticRenderFns } from "./JcdcExpansionPanels.vue?vue&type=template&id=c31ae7dc"
import script from "./JcdcExpansionPanels.vue?vue&type=script&lang=ts"
export * from "./JcdcExpansionPanels.vue?vue&type=script&lang=ts"
import style0 from "./JcdcExpansionPanels.vue?vue&type=style&index=0&id=c31ae7dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports